export default "__VITE_ASSET__DX_OOopG__"